module.exports = __webpack_public_path__ + "img/cigarette-intake-yes.c758407a.svg";